module.exports = TMap;